import React from 'react';
import styled, { css } from 'styled-components';
import { ModalSize } from '../Base';
import { Button, Icon } from '../../../elements';
export const Close = styled(Button).attrs({ icon: React.createElement(Icon.Close, null) }) `
  cursor: pointer;
  padding: 4px;

  &:after {
    box-shadow: 0 0 0 1px ${({ theme }) => theme.secondary.blendToBackground(150)} inset;
  }

  ${({ $isFixed }) => $isFixed &&
    css `
      position: absolute;
      inset: 8px 8px auto auto;
    `}
`;
export const Backdrop = styled.div `
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 13;
  opacity: 0;
  background-color: rgba(0 0 0 / 0%);
  transition:
    opacity 0.25s ease-out,
    overlay 0.25s ease-out allow-discrete,
    display 0.25s ease-out allow-discrete,
    background-color 0.25s ease-out allow-discrete;

  ${({ $open }) => $open &&
    css `
      opacity: 1;
      background-color: rgba(0 0 0 / 40%);
    `}
`;
export const Dialog = styled.dialog `
  position: relative;
  border: none;
  outline: none;
  margin: auto;
  padding: 0;
  box-sizing: border-box;
  border-radius: 12px;
  max-width: ${({ $size }) => $size ?? ModalSize.Small};
  width: 100%;
  min-width: 320px;
  height: fit-content;
  background-color: ${({ theme }) => theme.background};
  box-shadow:
    0 0 0 1px ${({ theme }) => theme.secondary.blendToBackground(1100, 150)},
    ${({ theme }) => theme.style.floatingShadowXL};

  z-index: 14;
  opacity: 0;
  transition:
    opacity 0.25s ease-out,
    overlay 0.25s ease-out allow-discrete,
    display 0.25s ease-out allow-discrete;

  &[open] {
    opacity: 1;
    display: block;
  }

  &:open {
    opacity: 1;
    display: block;
  }
`;
export const Wrapper = styled.div `
  padding: 4px;
  display: grid;
  place-items: center;
  position: fixed;
  overflow-y: auto;
  box-sizing: border-box;
  top: 0;
  left: 0;
  z-index: 14;
  width: 100vw;
  height: 100dvh;

  @starting-style {
    ${({ $open }) => $open &&
    css `
        ${Dialog} {
          &:not([open]):not(:open) {
            opacity: 0;
          }
        }

        ${Dialog}::backdrop {
          opacity: 0;
        }
      `}
    ${Backdrop} {
      opacity: 0;
    }
  }
`;
//# sourceMappingURL=Dialog.js.map